// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bei_a bia_ea bia_ke bia_ju bia_sn bia_wl"};